import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const login = useMutation({
    mutationFn: async () => {
      const res = await fetch("/api/v1/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = (await res.json()) as { error?: string; ok?: boolean };
      if (!res.ok) throw new Error(data.error ?? "Log masuk gagal");
      return data;
    },
    onSuccess: () => navigate("/admin"),
  });

  return (
    <div className="max-w-sm mx-auto px-6 py-16">
      <h1 className="text-2xl font-bold text-sea-700 mb-6 text-center">Log Masuk Admin</h1>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          login.mutate();
        }}
        className="bg-white rounded-xl shadow-sm p-6 space-y-4"
      >
        <div>
          <label className="block text-sm font-medium mb-1">E-mel</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full border rounded-lg px-3 py-2"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Kata Laluan</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border rounded-lg px-3 py-2"
            required
          />
        </div>
        {login.isError && <p className="text-red-600 text-sm">{(login.error as Error).message}</p>}
        <button
          type="submit"
          disabled={login.isPending}
          className="w-full bg-sea-500 text-white rounded-lg py-3 font-medium hover:bg-sea-600 transition disabled:opacity-50"
        >
          {login.isPending ? "Memproses..." : "Log Masuk"}
        </button>
      </form>
      {/* TODO Fasa 6 lanjutan: langkah kod TOTP selepas password betul, untuk akaun Owner */}
    </div>
  );
}
